import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';


export default function IdleTimerDialog(props) {
    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {'Session Timeout!'}
                    {/* <IconButton
                        aria-label="close"
                        onClick={props.onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.black,
                        }}
                    >
                        <CloseIcon />
                    </IconButton> */}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className='alert-description'>
                        <Typography>
                            Your session is about to expire due to inactivity. Do you want to stay logged in?
                        </Typography>
                    </DialogContentText>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CountdownCircleTimer
                        isPlaying
                        duration={59}
                        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                        colorsTime={[59, 45, 30, 0]}
                        size={50}
                        strokeWidth={6}
                    >
                        {({ remainingTime }) => remainingTime}
                    </CountdownCircleTimer>
                    </div>
                </DialogContent>
                <DialogActions className='idle-actions'>
                    <Button variant="contained" color="primary" autoFocus onClick={props.staylogin}>Stay login</Button>
                    <Button variant="outlined" color="primary" onClick={props.logout} >
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}